import commonservice from "@apis/commonservice";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import SMSWithCode, { PhoneRef } from "@pages/home/components/SMSWithCode";
import { updateSubmitLoading } from "@store/globalSlice";
import { Modal } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const PhoneVertifyModal = ({ onSubmit, open, setOpen }: { onSubmit: Function; open: boolean; setOpen: Function }) => {
  const refForm = useRef({} as PhoneRef & { captchaRef: { validateCaptchaError(val: unknown): void } });
  const isPricingPage = location.pathname === "/pricing";
  const { submitLoading } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // 发送验证码之前 前置校验
  const preconditionFn = async (nextFn: Function) => {
    // 验证手机号是否存在，如果存在直接结束，提示手机号存在
    let hasExist = await checkPhoneExistence();
    if ((hasExist as any)?.message) {
      return refForm.current.setPhone({
        validateStatus: "error",
        errorMsg: !isPricingPage
          ? t("The number is linked to another account. You can try another number.")
          : t(
              "The number is linked to another account. You can try another number or log out of the current account, then log in with this entered number to complete the payment. ",
            ),
      });
    }
    await nextFn?.();
  };

  const checkPhoneExistence = async () => {
    const formData = refForm.current.getFieldsValue();
    return commonservice
      .checkPhoneNumberIsExist({
        phoneCountryCode: formData.prefix || "",
        phoneNumber: formData.phone || "",
      })
      .catch((err) => {
        return Promise.resolve(err);
      });
  };

  return (
    <div className="Component_PhoneVertifyModal">
      <Modal
        className="Component-BasicModal Modal-SubAccountPhoneVertifyModal"
        title={isPricingPage ? t("Please verify your number before payment") : t("Verify")}
        open={open}
        confirmLoading={submitLoading}
        onOk={async () => {
          dispatch(updateSubmitLoading(true));
          await preconditionFn(async () => {
            try {
              await onSubmit(refForm.current.getFieldsValue());
            } catch (err) {
              refForm.current.captchaRef.validateCaptchaError((err as any)?.message || err);
            }
          });
          dispatch(updateSubmitLoading(false));
        }}
        onCancel={() => {
          setOpen(false);
          refForm.current.resetFields();
          refForm.current.setPhone({
            validateStatus: "success",
            errorMsg: "",
          });
          dispatch(updateSubmitLoading(false));
          refForm.current?.captchaRef?.validateCaptchaError("");
        }}
        cancelText={t("Cancel")}
        okText={t("Confirm")}
        destroyOnHidden={true}
      >
        <div className="p-[16px]">
          <SMSWithCode
            // preconditionFn 有这个方法 会在发送验证码之前调用该方法
            preconditionFn={preconditionFn}
            ref={refForm}
            type="verify"
          />
        </div>
      </Modal>
    </div>
  );
};

export default PhoneVertifyModal;
